import React from "react";
import * as icons from "lucide-react";

/* Manifest-driven tab bar (ADR-008).

   Receives an ordered list of `tabs` from the backend workspace-manifest
   endpoint. The active tab is controlled by the parent so URL routing
   can drive selection later.
*/
export default function TabBar({ tabs, activeId, onSelect }) {
  return (
    <div
      role="tablist"
      aria-label="Property Workspace tabs"
      data-testid="workspace-tab-bar"
      className="flex items-center gap-0.5 overflow-x-auto border-b border-slate-200 -mx-6 px-6"
    >
      {tabs.map((t) => {
        const Icon = t.icon ? iconFor(t.icon) : null;
        const isActive = t.id === activeId;
        return (
          <button
            key={t.id}
            role="tab"
            aria-selected={isActive}
            data-testid={`workspace-tab-${t.id}`}
            onClick={() => onSelect?.(t.id)}
            className={`flex items-center gap-1.5 whitespace-nowrap px-3 py-2 text-[13px] transition-colors border-b-2
              ${isActive
                ? "text-amber-800 border-amber-400"
                : "text-slate-600 border-transparent hover:text-slate-900 hover:border-slate-300"}`}
          >
            {Icon ? <Icon size={13} /> : null}
            <span>{t.label}</span>
            {!t.enabled ? (
              <span className="text-[9px] uppercase tracking-wider px-1 py-0.5 rounded bg-slate-50 text-slate-500 border border-slate-100">
                soon
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}

// Lucide export names are PascalCase, backend passes kebab-case; convert on demand.
function iconFor(name) {
  const camel = name.replace(/(^|-)([a-z])/g, (_, __, c) => c.toUpperCase());
  return icons[camel] || icons.Square;
}
